import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

export const Hero = () => {
  const scrollToWork = () => {
    const element = document.getElementById('work');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center overflow-hidden pt-24"
    >
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://static.prod-images.emergentagent.com/jobs/019b4c41-3267-4b2f-8cd8-cbbc3514ec1e/images/7dba2badbfad076ac12a07eac529c5b0409ad1770b46d14562a9af09fb326aae.png')`,
        }}
      />
      
      {/* Overlay */}
      <div className="absolute inset-0 hero-overlay" />
      
      {/* Noise texture */}
      <div className="absolute inset-0 noise pointer-events-none" />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
          className="space-y-8"
        >
          {/* Headline */}
          <h1
            data-testid="hero-headline"
            className="font-['Sora'] text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold tracking-tight text-foreground leading-[1.1]"
          >
            Creative Design for
            <br />
            <span className="text-primary">Brands, Businesses</span>
            <br />
            & Digital Presence
          </h1>

          {/* Subheadline */}
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            data-testid="hero-subheadline"
            className="text-base sm:text-lg text-muted-foreground max-w-2xl mx-auto leading-relaxed"
          >
            Damian Depasquale Creative Studio is focused on branding, visual identity,
            social media design, and standout digital visuals tailored to modern
            businesses and creators.
          </motion.p>

          {/* CTA Buttons */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4"
          >
            <Button
              onClick={scrollToWork}
              data-testid="hero-view-work-btn"
              variant="outline"
              className="rounded-full px-8 py-6 text-base border-border/50 hover:border-primary hover:text-primary transition-all group"
            >
              View Work
              <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Link to="/start-project" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
              <Button
                data-testid="hero-start-project-btn"
                className="bg-primary hover:bg-primary/90 text-primary-foreground rounded-full px-8 py-6 text-base btn-shine"
              >
                Start a Project
              </Button>
            </Link>
          </motion.div>

          {/* Services Tag Line */}
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            data-testid="hero-services-line"
            className="text-sm text-muted-foreground/70 pt-8 tracking-wider"
          >
            Branding & Identity &bull; Digital Design &bull; Graphic Design &bull; Web Design & Development &bull; Sports Design
          </motion.p>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
